<header class="main-header" [ngClass]="{ 'main-header--hidden': headerAnimationService.headerHidden$ | async }">
  <a class="main-header__logo" routerLink="/">
    <img src="/assets/fenix-logo-dark.svg" width="200" height="45" alt="Logo" />
  </a>

  <div class="main-header__user-menu" (click)="menu.toggle($event); toggleUserMenu()">
    <p class="main-header__username">{{ userName }}</p>
    <div class="main-header__icon" [ngClass]="{ 'main-header__icon--flipped': isUserMenuOpen }">
      <i class="fal fa-angle-down"></i>
    </div>
  </div>
</header>

<p-menu #menu popup [model]="items" (onHide)="toggleUserMenu(false)" class="main-header__logout-menu"></p-menu>
